import { Box, Typography } from "@mui/material";
import { useStyle } from "./style";
import { CopyTextFieldIcon } from "./CopyTextFieldIcon";

interface IParams {
    text: string;
    width?: React.CSSProperties["width"];
}

export const CopyTextField = (props: IParams) => {
    const { text, width } = props;
    const { classes } = useStyle({ width });

    return (
        <Box alignItems="center" display="flex" width={width}>
            <div className={classes.container}>
                <Typography color="secondary" variant="subtitle2">
                    {text}
                </Typography>
                <CopyTextFieldIcon textToCopy={text} />
            </div>
        </Box>
    );
};
